// extracted by mini-css-extract-plugin
export default {"frequentlyAskedQuestions":"faq_frequentlyAskedQuestions__RS1LI","faqTitle":"faq_faqTitle__O2LaZ"};